import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { walletWhitelist } from "../../rbac-consts";
import ClientWalletWhitelistContainer from "./client/WalletWhitelistContainer";

const WalletWhitelistWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={walletWhitelist.USER}
        yes={() => (
          <ClientWalletWhitelistContainer match={match} />
        )}
      />
    </>
  );
};

export default WalletWhitelistWrapper;